
import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h1 className="text-4xl font-serif font-bold text-stone-900">Gizlilik Politikası</h1>
        <div className="prose prose-stone text-stone-600 space-y-8 font-medium">
          <p>Lumina Home olarak kişisel verilerinizin güvenliği bizim için çok değerlidir. Web sitemizde paylaştığınız hiçbir bilgi üçüncü taraflarla paylaşılmaz.</p>
          <p>Ödeme işlemleriniz 256-bit SSL sertifikası ile doğrudan PayTR altyapısı üzerinden gerçekleştirilir. Kart bilgileriniz hiçbir şekilde sunucularımızda saklanmaz.</p>
          <p>Kayıtlı e-posta adresleriniz sadece sipariş bilgilendirmeleri ve bülten onayınız varsa kampanya duyuruları için kullanılır.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
